import { render, staticRenderFns } from "./AddDepartment.vue?vue&type=template&id=5688cc0b&scoped=true"
import script from "./AddDepartment.vue?vue&type=script&lang=js"
export * from "./AddDepartment.vue?vue&type=script&lang=js"
import style0 from "./AddDepartment.vue?vue&type=style&index=0&id=5688cc0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5688cc0b",
  null
  
)

export default component.exports